import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/teams-v2/appEnv';

export default appStarterFactory(appEnv);
